import React from 'react';
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {BurgerIcon} from "@ui/icons/icons";
import {useViewContext} from "@context/viewContext/hooks/useViewContext";

const HideSidebarBtn = () => {

    const {setHideSidebar} = useViewContext()
    const onClick = () => {
        setHideSidebar((prev) => !prev)
    }
    return (
        <IconButtonCustom
            onClick={onClick}
            variant={'empty'}
        >
            <BurgerIcon/>
        </IconButtonCustom>
    );
};

export default HideSidebarBtn;